import { authApi } from '../../utils/api';

export const adminBelgelerPage = () => {
    const user = authApi.getCurrentUser();

    if (!user || user.rol !== 'admin') {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-danger">
                        <p>Bu sayfaya erişim yetkiniz yok.</p>
                        <a href="/" class="btn-primary">Ana Sayfaya Dön</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content admin-page">
            <div class="container">
                <div class="page-header">
                    <h1 class="page-title">Belge Yönetimi</h1>
                    <div class="header-actions">
                        <a href="/admin" class="btn-outline">← Admin Paneli</a>
                        <button class="btn-primary" id="addBelgeBtn">+ Belge Yükle</button>
                    </div>
                </div>

                <div id="belgeModal" class="modal" style="display: none;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2>Belge Yükle</h2>
                            <button class="modal-close" id="closeBelgeModal">&times;</button>
                        </div>
                        <form id="belgeForm" class="modal-form" enctype="multipart/form-data">
                            <div class="form-group">
                                <label for="belgeTipi">Belge Tipi *</label>
                                <select id="belgeTipi" class="form-control" required>
                                    <option value="">Seçin</option>
                                    <option value="police_pdf">Poliçe PDF</option>
                                    <option value="evrak">Evrak</option>
                                    <option value="teminat">Teminat Belgesi</option>
                                    <option value="diger">Diğer</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="belgeUserId">Müşteri</label>
                                <select id="belgeUserId" class="form-control">
                                    <option value="">Müşteri Seçin (Opsiyonel)</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="belgePoliceId">Poliçe No</label>
                                <select id="belgePoliceId" class="form-control">
                                    <option value="">Poliçe Seçin (Opsiyonel)</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="belgeDosya">Dosya * (PDF veya Resim)</label>
                                <input type="file" id="belgeDosya" class="form-control" accept=".pdf,.jpg,.jpeg,.png,.gif,.webp" required>
                            </div>
                            <div class="form-group">
                                <label for="belgeAciklama">Açıklama</label>
                                <input type="text" id="belgeAciklama" class="form-control" placeholder="Belge açıklaması">
                            </div>
                            <div id="belgeFormError" class="error-message" style="display: none;"></div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelBelgeBtn">İptal</button>
                                <button type="submit" class="btn-primary">Yükle</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div id="belgelerList" class="data-table-container">
                    <div class="loading">Yükleniyor...</div>
                </div>
            </div>
        </section>
    `;
};
